export default "__VITE_ASSET__DaXZzyV$__"